import { type LookalikeFormSegment, lookalikeSpecificCategory } from '../../../../types.ts';
import type { GroupedLookalikeDefinition } from './groupLookalikeDefinitions.ts';

export const getExistingSegmentsForDefinition = (
  segments: LookalikeFormSegment[],
  definitionId: string
): GroupedLookalikeDefinition => {
  return segments.reduce<GroupedLookalikeDefinition>((acc, segment) => {
    if (segment.lookalike_definition_id !== definitionId) return acc;

    if (segment.sub_category === lookalikeSpecificCategory.Similarity) {
      acc.similaritySegment = segment;
    } else if (segment.sub_category === lookalikeSpecificCategory.SeedAggregate) {
      acc.seedSegment = segment;
    }

    return acc;
  }, {});
};
